<template>
  <div id="transkribusEditor">
    <Editor v-if="xmlJsonString" :iiifUrl="iiifUrl" :xmlJson="toJsonObject" />
    <Editor v-else :iiifUrl="iiifUrl" :xmlJson="xmlJson" />
  </div>
</template>

<script>
// Test page : http://localhost:5000/collection/76950/doc/497355/detail/1

import Editor from "./views/Editor.vue";
import { mapState, mapGetters } from "vuex";

const json = require("./assets/page_clean.json");

export default {
  name: "transkribusEditor",
  props: {
    iiifUrl: {
      type: String,
      default: () =>
        "https://files.transkribus.eu/iiif/2/XITIHIQXRRBAHPZDHDPHWHMP/info.json",
    },
    xmlJson: {
      type: Object,
      default: () => json,
    },
    xmlJsonString: {
      type: String,
    },
    xml: {
      type: String,
    },
    tags: {
      type: String,
    },
  },
  watch: {
    iiifUrl: {
      handler: async function (newValue, oldValue) {
        console.log("set IIIF", newValue);
        this.$store.dispatch("content/setIIIF", {
          iiifUrl: newValue,
        });
      },
      deep: true,
    },
    xml: {
      handler: async function (newValue, oldValue) {
        console.log("set XML", newValue);

        this.$store.dispatch("content/setXml", {
          xml: newValue,
        });
      },
      deep: true,
    },
    tags: {
      handler: async function (newValue, oldValue) {
        var cleanedString = this.escapeSpecialChars(newValue);
        const obj = JSON.parse(cleanedString);
        console.log("set Tags", obj);
        this.$store.dispatch("browse/setTagDefs", { tagDefs: obj });
      },
      deep: true,
    },
    xmlJsonString: {
      handler: async function (newValue, oldValue) {
        console.log("set xmlJsonString", this.toJsonObject);
        this.$store.dispatch("content/setXmlJson", {
          xmlJson: this.toJsonObject,
        });
      },
      deep: true,
    },
  },
  methods: {
    escapeSpecialChars(string) {
      return string
        .replace(/\\n/g, "\\n")
        .replace(/\\'/g, "\\'")
        .replace(/\\"/g, '\\"')
        .replace(/\\&/g, "\\&")
        .replace(/\\r/g, "\\r")
        .replace(/\\t/g, "\\t")
        .replace(/\\b/g, "\\b")
        .replace(/\\f/g, "\\f");
    },
  },
  components: {
    Editor,
  },
  computed: {
    toJsonObject() {
      var cleanedString = this.escapeSpecialChars(this.xmlJsonString);
      const obj = JSON.parse(cleanedString);
      return obj;
    },
    // ...mapState("content", [
    //   "data",
    //   "selected",
    //   "highlighted",
    //   "fetchPageContent",
    //   "iiifUrl",
    //   "xmlJson",
    // ]),
  },
  mounted() {
    if (this.iiifUrl) {
      console.log("set IIIF", this.iiifUrl);
      this.$store.dispatch("content/setIIIF", {
        iiifUrl: this.iiifUrl,
      });
    }
    if (this.xml) {
      console.log("set XML", this.xml);
      this.$store.dispatch("content/setXml", {
        xml: this.xml,
      });
    }
    if (this.xmlJsonString) {
      console.log("set xmlJsonString", this.xmlJsonString);
      this.$store.dispatch("content/setXmlJson", {
        xmlJson: this.toJsonObject,
      });
    }
    if (this.tags) {
      console.log("set tags", this.tags);
      var cleanedString = this.escapeSpecialChars(this.tags);
      const obj = JSON.parse(cleanedString);
      this.$store.dispatch("browse/setTagDefs", { tagDefs: obj });
    }
  },
};
</script>
<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "assets/variables.scss";
@import "assets/styles.scss";

@import "bulma";
@import "buefy/src/scss/buefy";
</style>
